import { NuveiGooglePayForm } from '@/components/PaymentForms/NuveiGooglePayForm';
import type { ExpressCheckoutComponentProps } from '@/types/expressCheckout';
/** Express-row adapter — keeps `expressPayment` aligned with Adyen/Stripe wallet modules. */
export const NuveiGooglePay = (props: ExpressCheckoutComponentProps) => <NuveiGooglePayForm {...props} />;
